import gql from 'graphql-tag'

export default gql`
  subscription onAuditoriaProcessoAdded {
    auditoriaProcessoAdded {
      id
    }
  }
`
